import React, { useState } from "react";
import { CheckIcon, MagnifyingGlassIcon } from "@heroicons/react/20/solid";
import { Combobox } from "@headlessui/react";
import { useQuery } from "@apollo/client";
import physicians from "../../../../gql/physicians";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function PractionerSearchNSelect({ setFieldValue }) {
  const [query, setQuery] = useState("");
  const [selectedPractioner, setSelectedPractioner] = useState(null);

  const [people, setPeople] = useState([]);

  const formatData = (data) => {
    let returnData = [];
    if (data?.length > 0) {
      data.map((item) => {
        returnData.push({
          id: item.id,
          DocumentId: item.document_id,
          ProvidersId: item.providers_id,
          name: item.name,
          Speciality: item.speciality,
          Role: item.role,
          License: item.license,
          StatusId: item.status_id,
          NphiesId: item.nphies_id,
        });
      });
    } else {
    }
    return returnData;
  };

  const {
    loading: loadingPhysicians,
    error: errorPhysician,
    data: physiciansData,
    refetch,
  } = useQuery(physicians.GET_SEARCHED_PHYSICIANS, {
    variables: { q: "abcdefgh*%^%" },
  });

  React.useEffect(() => {
    if (physiciansData) {
      setPeople(formatData(physiciansData?.searchPhysicians?.data));
    }
  }, [physiciansData]);

  const filteredPeople =
    query === ""
      ? people
      : people.filter((person) => {
          let searched = person.name
            .toLowerCase()
            .includes(query.toLowerCase());
          if (!searched) {
            searched = person.name.toLowerCase().includes(query.toLowerCase());
          }
          return searched;
        });

  const onSearch = (inputText) => {
    setQuery(inputText);
    if (inputText.length > 2) {
      refetch({ q: inputText });
    } else {
    }
  };

  return (
    <Combobox
      as="div"
      value={selectedPractioner}
      onChange={(val) => {
        setSelectedPractioner(val);
        setFieldValue(val);
      }}
    >
      {/* <Combobox.Label className="block text-sm font-medium leading-6 text-gray-900">
          Select Beneficiary
        </Combobox.Label> */}
      <div className="relative">
        <Combobox.Input
          className=""
          onChange={(event) => onSearch(event.target.value)}
          displayValue={(person) => person?.name}
          placeholder={"Search for Practioner"}
        />
        {/* <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
          <MagnifyingGlassIcon
            className="h-5 w-5 text-gray-400"
            aria-hidden="true"
          />
        </Combobox.Button> */}

        {filteredPeople.length > 0 && (
          <Combobox.Options className="w-auto absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
            {filteredPeople.map((person) => (
              <Combobox.Option
                key={person.id}
                value={person}
                className={({ active }) =>
                  classNames(
                    "relative cursor-default select-none py-2 pl-3 pr-9",
                    active ? "bg-amber-600 text-white" : "text-gray-900"
                  )
                }
              >
                {({ active, selected }) => (
                  <>
                    <span
                      className={classNames(
                        "block truncate",
                        selected && "font-semibold"
                      )}
                    >
                      {person.name}
                    </span>

                    {selected && (
                      <span
                        className={classNames(
                          "absolute inset-y-0 right-0 flex items-center pr-4",
                          active ? "text-white" : "text-amber-600"
                        )}
                      >
                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                      </span>
                    )}
                  </>
                )}
              </Combobox.Option>
            ))}
          </Combobox.Options>
        )}
      </div>
    </Combobox>
  );
}

export default PractionerSearchNSelect;
